(function() {
  'use strict';

  angular.module('app.customerAccount', []);
})();
